import React, { useState, useEffect } from 'react';
import './OptimizedImage.css';

const OptimizedImage = ({ 
  src, 
  srcSet, 
  sizes, 
  alt, 
  className = '', 
  placeholder = null,
  onLoad,
  onError 
}) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Preload the image for better performance
  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      // Image is preloaded
    };
  }, [src]);

  const handleImageLoad = () => {
    setImageLoaded(true);
    if (onLoad) onLoad();
  };

  const handleImageError = () => {
    setImageError(true);
    if (onError) onError();
  };

  return (
    <div className={`optimized-image-container ${className}`}>
      {!imageLoaded && !imageError && (
        <div className="image-placeholder">
          {placeholder || (
            <>
              <div className="loading-spinner"></div>
              <p>Cargando imagen...</p>
            </>
          )}
        </div>
      )}
      
      {imageError && (
        <div className="image-error">
          <p>Error al cargar la imagen</p>
        </div>
      )}
      
      <img 
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        alt={alt}
        className={`optimized-image ${imageLoaded ? 'loaded' : ''}`}
        loading="lazy"
        onLoad={handleImageLoad}
        onError={handleImageError}
        style={{ display: imageLoaded ? 'block' : 'none' }}
      />
    </div>
  );
};

export default OptimizedImage; 